
export interface DiscriminationConfiguration {
    rules: { [key: number]: DiscriminationRule };
    rulesList : number[];
    exclusions: { [key: number]: DiscriminationEntryExclusion };
    exclusionsFoodItemSetList: { [key: number]: DiscriminationFoodItemSetExclusion };
}

export interface DiscriminationState  {
    configuration: DiscriminationConfiguration;
    ruleByFoodItem: { [foodItemId: number]: number[] };
    ruleByFoodItemSet: { [foodItemId: number]: number[] };
    rulePortionCounter: { [ruleId: number]: number };
    ruleVSECounter: { [ruleId: number]: number };
    ruleTypeCounter: { [ruleId: number]: number };
    courseGroupSets: { [courseGroup: number]: number[] }
}

export const initialDiscriminationState: DiscriminationState = {
    configuration: {
        rules: {},
        rulesList : [],
        exclusions: [],        
        exclusionsFoodItemSetList: []
    },
    ruleByFoodItem: {},
    ruleByFoodItemSet: {},
    rulePortionCounter: {},
    ruleVSECounter: {},
    ruleTypeCounter: {},
    courseGroupSets: {}
}

export interface DiscriminationLock {
    foodItemId : number;
    reason: string;
}

export interface DiscriminationRule {
    setNr: number;
    setName: number;
    components: number[];
    foodItems: number[];
    dependencies: DiscriminationSetDependency[];
    maxima: DiscriminationSetMaximum;
    patientVSEComponent: DiscriminationVSEComponent[];
    patientNutritionDietComponent: DiscriminationPatientNutritionDietComponent[];
}

export interface DiscriminationSetDependency {
    sourceNutrition: number;
    sourceDiet: number;
    sourceMinimumPortion: number;
    sourceMaximumPortion: number;
    targetDependencySetNr: number;
    targetMaximumPortion: number;
}

export interface DiscriminationSetMaximum {
    maximumNutrition: number;
    maximumDiet: number;
    maximumTypes: number;
    maximumPortions: number;
}

export interface DiscriminationEntryExclusion {
    id: number;
    entryExclusionNutritionNr: number;
    entryExclusionEntryNr: number;
    entryExclusionSets: number[];
    entryExclusionForbiddenFoodItems: number[];
}

export interface DiscriminationFoodItemSetExclusion {
    id: number;
    exceptionNutritionNr: number;
    exceptionChosenFoodItems: number[];
    exceptionForbiddenFoodItems: number[];
}

export interface DiscriminationVSEComponent {
    meal: number;
    component: number;
    vse: number;
}

export interface DiscriminationPatientNutritionDietComponent {
    meal: number;
    component: number;
    nutrition: number;
    diet: number;
}